import { CustomerSupportImage } from '@/legacy-src/components/CustomerSupportImage'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Heading } from '@/src/domains/design-system/components/Heading'

import { HeaderSupportButton } from './HeaderSupportButton'
import { HeaderSupportChatButton } from './HeaderSupportChatButton'

export const HeaderSupport = () => {
  const { t } = getTranslate()

  return (
    <div className="mb-8 mt-8 flex flex-col gap-6 border-0 border-t-2 border-solid border-sand-400 pt-8 laptop:mb-0 laptop:mt-11 laptop:flex-row laptop:items-center laptop:justify-between">
      <div className="flex items-center gap-6">
        <Heading element="h3" variant="xl" className="order-1 text-secondary">
          {t('component.navigation.helpTitle')}
        </Heading>
        <CustomerSupportImage size="small" />
      </div>
      <ul className="m-0 flex list-none flex-col gap-3 p-0 laptop:flex-row">
        <li>
          <HeaderSupportChatButton />
        </li>
        <li>
          <HeaderSupportButton href={`mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}`} icon="email">
            {t('component.navigation.helpEmail')}
          </HeaderSupportButton>
        </li>
      </ul>
    </div>
  )
}
